module.exports = __webpack_public_path__ + "img/laptop-02.82e1c202.svg";